// Image field constants shared by the generic CRUD drawer and rich editors.

// Which fields on any resource render as image uploads (vs. plain text).
export const IMAGE_FIELDS = new Set(["image", "logo", "icon_url"]);

// Recommended image dimensions per collection + field. Keyed as `${resource}.${field}`.
export const IMAGE_RECOMMENDATIONS = {
  "services.image": {
    size: "1200 × 960 px",
    ratio: "5:4",
    format: "JPG or WEBP",
    note: "Landscape hero for the service card. Focus subject on the left third.",
  },
  "portfolio.image": {
    size: "1200 × 900 px",
    ratio: "4:3",
    format: "JPG or WEBP",
    note: "Portrait, wide product shot or brand mockup.",
  },
  "laptops.image": {
    size: "1200 × 900 px",
    ratio: "4:3",
    format: "Transparent PNG",
    note: "Laptop cut-out on transparent background. Do NOT include shadows baked in.",
  },
  "laptops.icon_url": {
    size: "128 × 128 px",
    ratio: "1:1",
    format: "SVG or transparent PNG",
    note: "Small line icon shown next to the setup title (orange stroke).",
  },
  "software.logo": {
    size: "300 × 300 px",
    ratio: "1:1",
    format: "SVG or transparent PNG",
    note: "Brand logo shown in the software grid. Square canvas, centered.",
  },
  "brands.logo": {
    size: "400 × 150 px",
    ratio: "8:3 (wordmark)",
    format: "SVG or transparent PNG",
    note: "Client wordmark for the carousel. Grayscale renders on the site by default.",
  },
  "testimonials.image": {
    size: "1200 × 900 px",
    ratio: "4:3",
    format: "JPG or WEBP",
    note: "Optional per-testimonial photo. Leave blank to fall back to the global Testimonial Image in Site Settings.",
  },
};
